
import Vue from 'vue'
export default Vue.extend({
  data() {
    return {
      items: [
        {
          title:
            '現場スタッフも、マネージャークラスも迷わず使えるインターフェイス設計',
          description:
            '優れた機能を持ったシステムも、導入が大変で使い心地が悪ければ長く使ってもらえません。スリーズプロは、現場スタッフもマネージャークラスも迷わず使えるインターフェイスを設計。現場への導入からシステム稼働まで、ストレスなく進められます。',
          num: '01',
          img: '/overview/selectPoint01.png',
          isRight: false,
          cardItems: [
            {
              icon: 'security-icon',
              title: 'スマホ・タブレットで対応',
              description:
                '現場スタッフはスマホ・タブレット・PCのみで業務をおこなうことができます。画面上で問診から施術歴の入力、会計ができるので効率よく業務が進められます。',
            },
            {
              icon: 'paint-icon',
              title: 'ナビゲート機能でフォーム入力と導入サポート',
              description:
                '初期設定などの入力手順や内容をナビゲートでご案内。各種設定がカンタンにできます。',
            },
            {
              icon: 'commit-icon',
              title: '直感的にわかる管理画面',
              description:
                '直感的に操作できるインターフェイス。スマホ・PCどちらにも最適化され、現場スタッフの業務もスマホ１つでおこなえます。',
            },
          ],
        },
        {
          title: '導入サポートで、現場スタッフの負担なくSmart治療院を実現',
          description:
            '多くの企業は、システム部を持っておらす、マネージャーや院長などの現場スタッフがシステム導入のサポートをするため、現場スタッフの負担が多くなります。ですが、スリーズプロでは、オプションで導入サポートがあるので、企業様・現場スタッフの負担なく。システム導入できます。',
          num: '02',
          img: '/overview/selectPoint02.png',
          isRight: true,
          cardItems: [
            {
              icon: 'security-icon',
              title: 'チャットで質問',
              description:
                'スリーズプロのシステム内に、質問チャット機能を備えているので、気楽にチャットで質問ができます。',
            },
            {
              icon: 'paint-icon',
              title: 'オンライン対応',
              description:
                'オンラインで、実際の画面を共有して操作方法や疑問点を解決していきますので、ムリなくスムーズに導入ができます。',
            },
            {
              icon: 'commit-icon',
              title: '導入計画の策定',
              description:
                'ストレスなく、導入するために代理で計画を作成・現場スタッフへ落とし込みをおこないます。Smart運営のイメージが湧くので、期待感も高まります。',
            },
            {
              icon: 'text-file',
              title: 'データ移行も可能',
              description:
                '現在使用している他社のシステムデータの移行も可能です。いままでの顧客データを失うことなく活用できます。',
            },
          ],
        },
        {
          title: 'Smart運営を実現するための充実したサポートコンテンツ',
          description:
            '大切な機能を最大限活用いただくため、導入・運用に関する充実したサポートコンテンツをご用意しています。システムは日々アップデートされ、常に最新の情報を掲載。初めての導入でも安心してご利用いただけます。',
          num: '03',
          img: '/overview/selectPoint03.png',
          isRight: false,
          cardItems: [
            {
              icon: 'security-icon',
              title: '導入前',
              description:
                '御社に変わって、現場の意見や不安・不満を一手に引き受けます。',
            },
            {
              icon: 'paint-icon',
              title: '導入後',
              description:
                '「現場の窓口になります」操作方法からアップデートされた機能の使い方がわからない場合なども導入時と変わらず、手厚くサポートさせて頂きます。',
            },
            {
              icon: 'commit-icon',
              title: '運用',
              description:
                '経営者・幹部・院長の方々に手間は取らせません。導入経験が豊富な担当スタッフが導入に関して、現場の声をフィードバックし、全て解決しますので、ご安心ください。',
            },
          ],
        },
      ],
    }
  },
})
